
































































import { Component, Vue } from 'vue-property-decorator';

import Typography from '@/components/atoms/Typography/Typography.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import BusinessBox from '@/components/molecules/BusinessBox/BusinessBox.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import { setSessionSignup } from '@/views/Signup/session';

import { IBusiness } from '@/store/modules/managerTypes';
import {
  getOauthState,
  removeExternalOauthSession,
  removeOauthState,
  setOauthState
} from '@/router/router-utils';
import PlusCircle from '@/components/icons/PlusCircle.vue';
import { IBusinessType } from '@/models/business';
import APIService from '@/api';
import { merchantoauthSessionKeys } from '@/constants/merchantoauth';
import { treatError } from '@/utils';
import ManagerService from '@/api/ManagerService';
import MerchantService from '@/api/MerchantService';
import { getSignUpUrlRoutes } from '../Onboarding/helpers';
import { isOnlineProvider } from '@/utils/provider';

@Component({
  components: {
    Typography,
    BusinessBox,
    FilledButton,
    Picture,
    PlusCircle
  }
})
export default class SelectBusiness extends Vue {
  oauthState = getOauthState();
  managerService = new ManagerService();
  merchantService = new MerchantService();
  businessList: IBusiness[] = [];

  get provider() {
    if (!this.oauthState) return {};
    return this.oauthState.provider;
  }

  loadBusinessList() {
    const providers = this.providersList;
    const businesses = this.$store.getters['manager/getBusinessList'];
    this.businessList = businesses
      .map((business: any) => {
        business.providers = business.providers
          .filter((connected: any) => isOnlineProvider(connected.provider))
          .map((connected: any) => {
            return (
              providers.find(p => p.name === connected.provider) || connected
            );
          });
        business.disabled = business.providers.length > 0;
        return business;
      })
      .sort((a: any, b: any) => {
        return a.providers.length - b.providers.length;
      });
  }

  get providersList(): any[] {
    return this.$store.getters['merchant/getProvidersList'];
  }

  get name() {
    if (!this.$store.getters['manager/getExtraInfo']) return 'Merchant';
    return this.$store.getters['manager/getExtraInfo'].fullname.split(' ')[0];
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  logout() {
    removeExternalOauthSession();
    APIService.resetCredentials();
  }

  getBusinessSubtitle(business: any) {
    if (business.providers.length > 0) {
      const providers = business.providers
        .map((p: any) => p.displayName)
        .join(', ');
      return `Connected to ${providers}`;
    }
    return '';
  }

  async handleSubmit(business?: any) {
    if (!business) {
      setOauthState({
        ...this.oauthState,
        selectedBusiness: undefined,
        countryUnavailableViewed: false,
        fromSelectBusinessRoute: true
      });
      if (
        this.oauthState &&
        this.oauthState.businessData &&
        this.oauthState.businessData.locations.length &&
        this.oauthState.businessData.locations[0].country
      ) {
        setSessionSignup({
          country: this.oauthState.businessData.locations[0].country,
          countryIso2: this.oauthState.businessData.locations[0].countryIso2
        });
      }

      this.$router.push(getSignUpUrlRoutes().YOUR_BUSINESS);
    } else {
      setOauthState({
        ...this.oauthState,
        selectedBusiness: business,
        fromSelectBusinessRoute: true
      });
      setSessionSignup({
        country: business.country,
        countryIso2: business.countryIso2
      });
      const isBusinessPhysical = business.type === IBusinessType.INSTORE;
      this.linkProviderInExistBusiness(
        isBusinessPhysical ? IBusinessType.BOTH : undefined
      );
    }
  }

  async linkProviderInExistBusiness(businessType?: string) {
    try {
      this.oauthState = getOauthState();
      this.$showLoaderWithLocker();
      await this.merchantService.signupConnectBusiness({
        oauthToken: this.oauthState.query.jwt,
        businessId: this.oauthState.selectedBusiness.id,
        type: businessType || this.oauthState.selectedBusiness.type || ''
      });
      await this.managerService.changeBusiness(
        this.oauthState.selectedBusiness.id
      );
      sessionStorage.setItem(
        merchantoauthSessionKeys.connect.success,
        `${this.oauthState.provider.displayName} connected.`
      );
      removeOauthState();
      this.$router.push('/settings/apps');
    } catch (e) {
      treatError(e);
    } finally {
      this.$hideLoader();
    }
  }

  created() {
    this.loadBusinessList();
  }
}
